import request from '../request'


const supportApis = {
  createSupportRequest: (payload) => request.post(`/customer-request`, payload),
  getAllCustomerRequest: (query) => request.get(`/customer-request${query}`),
  getCustomerRequest: (id, query) => request.get(`/customer-request/${id}${query}`),
  updateCustomerRequest: (id, payload) => request.patch(`/customer-request/${id}`, payload),
  createSupportResponse: (payload) => request.post(`/customer-response`, payload),
}

export default supportApis;